import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class AtelierRelevantAndConsideredCompleteControllerRequestService {
  private static BASE_URL =
    '/projects/atelierRelevantAndConsideredCompleteForBaseProjectOfProject';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as boolean;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      AtelierRelevantAndConsideredCompleteControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getAtelierRelevantAndConsideredCompleteForBaseProjectOfProject(
    projectId: number
  ): Promise<boolean> {
    return this.get(`/${projectId}`, this.deserialize).toPromise();
  }
}
